import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import './index.sass';

const ButtonOrganizations = ({ name, isActiveDropdown }) => (
	<button
		type="button"
		className="button has-radius-rounded style-componente-button-dropdow"
		data-testid="component-organizations-menu-button"
	>
		<div className="columns is-flex is-align-items-center component-style-itens">
			<div className="is-flex mr-3">
				<p
					className="has-text-white has-text-left has-text-caption style-text-button-dropdown"
					data-test="component-organizations-menu-button-name"
				>
					{name}
				</p>
			</div>
			<div className="is-flex">
				<span className="icon is-medium pt-2 has-text-white mb-1">
					<i
						className={`${isActiveDropdown
							? 'fa-light fa-angle-up'
							: 'fa-light fa-angle-down'
						}`}
						data-test="component-organizations-menu-icon"
					/>
				</span>
			</div>
		</div>
	</button>
);

ButtonOrganizations.propTypes = {
	name: PropTypes.string.isRequired,
	isActiveDropdown: PropTypes.bool.isRequired
};

export default injectIntl(ButtonOrganizations);
